<div class="privilege-item col-12 mb-2">
    <div class="privilege-title">
        <i class="fas fa-check mr-2"></i>
        <a href="#" @click.prevent="$emit('open')">
            👉 {{ item.title }}
        </a>
    </div>
    <div v-show="isOpen" class="privilege-description small py-2">
        {{ item.description }}
    </div>
</div>
